import * as React from "react";
import { SVGProps } from "react";

const Metaverse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="svg4852"
    viewBox="0 0 551 515"
    {...props}
  >
    <style>{".st13{fill:#3f3f3f}.st14{fill:#686a69}"}</style>
    <g id="layer1">
      <g id="g5474" transform="translate(-3.163 -281.382) scale(1.60742)">
        <circle
          id="path5411"
          cx={56.6}
          cy={428.8}
          r={34.9}
          fill="#de2813"
          transform="rotate(-1.146 56.626 428.783)"
        />
        <circle id="circle5413" cx={25.7} cy={358.2} r={23.7} fill="#e71619" />
        <circle
          id="circle5415"
          cx={39.3}
          cy={281.7}
          r={20.9}
          fill="#eb6617"
          fillOpacity={0}
        />
        <circle id="circle5417" cx={83.2} cy={218.5} r={18} fill="#ec6816" />
        <circle id="circle5419" cx={157} cy={188.8} r={13.7} fill="#f2961b" />
        <circle id="circle5421" cx={233.8} cy={199.6} r={11.4} fill="#f1c621" />
        <circle id="circle5423" cx={295.8} cy={248.9} r={8.5} fill="#f3c620" />
        <circle id="circle5425" cx={325.4} cy={321.2} r={19.8} fill="#156192" />
        <circle id="circle5427" cx={314.7} cy={397.5} r={17.7} fill="#2090c0" />
        <circle id="circle5429" cx={267.6} cy={458.3} r={13.8} fill="#338dcc" />
        <circle id="circle5431" cx={194} cy={486.3} r={9.1} fill="#38bae8" />
        <circle id="circle5433" cx={120.7} cy={475.6} r={6.3} fill="#36bbe6" />
        <circle
          id="circle5435"
          cx={39.5}
          cy={281.6}
          r={33.6}
          fill="#eb6617"
          transform="rotate(-3.17 39.484 281.585) scale(1.00003)"
        />
        <path
          id="rect5437"
          d="m115.5 310.2 27.9-15.9-.1 92.5-27.8 15.7v-92.3z"
          className="st13"
        />
        <path
          id="path5444"
          d="m226.7 310.2 27.9-15.9-.1 92.5-27.8 15.7v-92.3z"
          className="st13"
        />
        <path
          id="path5446"
          d="m171 310.2 27.9-15.9-.1 92.5-27.8 15.7v-92.3z"
          className="st13"
        />
        <path
          id="rect5448"
          d="m88.5 293.7 27.3-16.1 27.6 16.7-27.9 15.9-27-16.5z"
          className="st14"
        />
        <path
          id="path5451"
          d="m143.9 293.7 27.3-16.1 27.6 16.7-27.8 15.9-27.1-16.5z"
          className="st14"
        />
        <path
          id="path5453"
          d="m199.7 293.8 27.3-16.1 27.6 16.7-27.9 15.9-27-16.5z"
          className="st14"
        />
      </g>
    </g>
  </svg>
);

export default Metaverse;
